import styled from "styled-components";
import { Steps, Icon } from "antd";

export const FlowSteps = styled(Steps)`
  &&& {
    ${({disableSteppers}) => (disableSteppers ? 'opacity:0.5' : '')};
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    flex-direction: column;
    width: 176px;
    @media only screen and (max-width: 991.92px) {
      height: auto;
      position:relative;
      z-index: 5;
      background: linear-gradient(#fff,#fff), linear-gradient(#ffffff00,#ffffff00);
      background-repeat: no-repeat;
      background-size: 100% 90%, 100% 100%;
    }
    &.sticky {
      position: fixed;
      ${({affixRef}) => affixRef && affixRef.current && 'top:' + affixRef.current.offsetTop + 'px;'};
      z-index: 101;
    }
    &.stick-to-bottom {
      position: absolute;
      bottom: 0;
      top: auto;
    }
    .ant-steps-item-finish {
      cursor: ${props => (props.disableSteppers ? 'default' : 'pointer')};
    }
    .ant-steps-item {
      flex: none;
    }
    .ant-steps-item-process {
      cursor: ${props => (props.disableSteppers ? 'default' : 'pointer')};
    }
    .ant-steps-item-finish {
      text-align: left;
      transition: all 0.3s linear;
      .ant-steps-item-description {
        display: "none";
      }
      .ant-steps-item-title {
        display: flex;
      }
    }
    @media only screen and (max-width: 991.92px) {
      display: flex;
      flex-direction: row;
      margin-bottom: ${props => props.featureCode === 'GA' ? '75px' : '40px'};
      width: 100%;
    }
     /* added for contribution stepper fix */
      @media only screen and (max-width: 424px) {
        overflow-x: ${props => props.stepLength > 3 ? 'scroll' : ''};
        overflow-y: ${props => props.grantAgreement ? 'initial' : 'hidden'};
        &::-webkit-scrollbar { width: 0 !important; height:0 !important }
      }
      /* added for contribution stepper fix */
      .ant-steps-item {
        flex-shrink: 1;
        flex: auto;
      }
    }
  }
`;

export const ExchangeStep = styled(Steps.Step)`
  &&& {
    height: 149px;
    margin-right: 0;
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    border: 1px solid ${props => props.theme.border.stepperBorder};
    margin-bottom: 0.5rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    overflow: visible;
    .ant-steps-item-tail {
      display: none;
    }
    .ant-steps-item-icon {
      display: none;
    }
    .ant-steps-item-content {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
    .ant-steps-item-title {
      position: initial;
      width: 100%;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      height: 100%;
      padding: 0;
    }
    .ant-steps-item-description {
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.primary};
      line-height: ${props => props.theme.lineHeight.primary};
      letter-spacing: ${props => props.theme.letterSpacing.normal};
      color: ${props => props.theme.fontColors.blur};
      z-index: 5;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 1.25rem;
      max-width: 100%;
      & span {
        display: inline-block;
        margin-top: 35px;
        @media only screen and (min-width: 320px) and (max-width: 991px) {
          margin: 5px 0;
        }
      }
    }
    .ant-steps-item-title:after {
      display: none;
    }
    box-shadow: ${props => {
    if (props.active) {
      return "0 5px 10px 0 rgba(0, 0, 0, 0.1)";
    }
    return "none";
  }};
    @media only screen and (max-width: 991.92px) {
      flex-basis: auto;
      flex-shrink: 1;
      height: auto;
      text-align: center;
      margin-right: 5px;
      .ant-steps-item-content {
        padding-bottom: 0rem;
        overflow: visible;
      }
      .ant-steps-item-title {
        position: initial !important;
        line-height: 16px;
        height: auto;
        padding-left: 0.5rem;
        padding-right: 0.5rem !important;
      }
      .ant-steps-item-description {
        max-width: initial;
        display: ${props => (props.active ? "block" : "none")};
        font-size: ${props => props.theme.fontSize.tertiary};
      }
      &.ant-steps-item-process {
        text-align: left;
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: ${props => (props.active ? "block" : "none")};
          position: relative;
          bottom: 0;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          padding-bottom: 0px;
        }
      }
      &.ant-steps-item-finish {
        text-align: left;
        flex-basis: ${props => (props.active ? "63%" : "15%")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: "none";
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props => props.theme.backgroundColor.primaryColor};
          }
        }
      }
    }
    @media only screen and (max-width: 991px) {
      &:last-of-type {
        margin-bottom: 0.5rem;
      }
      .ant-steps-item-finish {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "0.001")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: none;
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props => props.theme.backgroundColor.primaryColor};
          }
        }
      }
    }
    @media only screen and (max-width: 480px) {
      &:last-of-type {
        margin-bottom: 0.5rem;
      }
      &.ant-steps-item-process {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "0.001")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: block;
        }
      }
      &.ant-steps-item-finish {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "0.001")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: none;
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props => props.theme.backgroundColor.primaryColor};
          }
        }
      }
      .ant-steps-item-description {
        font-size: ${props => props.theme.fontSize.tertiary};
      }
      .ant-steps-item-tail:after {
        display: none !important;
      }
    }
  }
`;

export const StepBand = styled.div`
  background-color: ${props => {
    if (props.active) {
      return props.theme.backgroundColor.primaryColor;
    }
    return props.theme.backgroundColor.layoutDark;
  }};
  z-index: 6;
  position: absolute;
  height: 100%;
  width: 6px;
  left: 0;
  & + div {
    padding-top: 1rem;
  }
  @media only screen and (max-width: 991.92px) {
    height: 3px;
    width: 100%;
  }
  @media only screen and (max-width: 480px) {
    & + div {
      font-size: 10px;
      padding-top: 0.5rem;
    }
  }
`;

export const StepNumber = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.active ? props.theme.fontColors.primary : props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-style: normal;
  font-stretch: normal;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 5;
  @media only screen and (max-width: 991.92px) {
    position: static;
    font-size: ${props => props.theme.fontSize.quaternary};
    padding: ${props => props.currentActive ? "0.75rem 0 0.25rem" : "1.6rem 0 0.25rem"};
    text-align: left;
  }
`;

export const ActiveIcon = styled(Icon)`
  z-index: ${props => props.raise ? 5 : 3};
  position: absolute;
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.white};
  right: -26px;
  top: 45%;
  transform: translate(-45%, 0);
  opacity: ${props => {
    if (props.active) {
      return "0.9";
    }
    return "0";
  }};
  @media only screen and (max-width: 991.92px) {
    font-size: 16px;
    color: white;
    top: calc(100% - 6px);
    left: 50%;
    right: unset;
    transform: translate(-45%, 0) rotate(90deg);
  }
`;

export const SnagSection = styled.div`
  margin-top:50px;
  @media only screen and (max-width: 990px) {
    display:flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 40px;
    margin-top: 0;
    position: absolute;
    top: 80px;
    width: 98%;
}
`;

export const ContactPara = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  margin: 0px;
  a {
    color: ${props => props.theme.fontColors.primary};
  }
  @media only screen and (min-width: 992px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    width: 105px;
  }
`;

export const SnagHeader = styled.h4`
  font-size: ${props => props.theme.fontSize.h5};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  margin-bottom: 0;
  @media only screen and (min-width: 992px) {
    margin-bottom: 15px;
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
  }
`;
